import React from "react";

import { ChipWrapper } from "./styles";

const Chip = ({ text, background, style, ...props }) => {
  return (
    <ChipWrapper style={style} background={background} {...props}>
      {text}
    </ChipWrapper>
  );
};

export default Chip;
